import { IUpdateJustificationAbsenceDto, IUploadJustificacationAbsencesDto } from "../../models/dto/justificationAbsences/IJustificationAbsenceModelDto";
import * as ApiWithToken from "../callApiWithToken";
const apiUrl = process.env.REACT_APP_GENERAL_API;

const justificationAbsencesService = {
  GetAbsencesWithoutJustificationFile: async function (languageID: number, startDate: string, endDate: string) {
    let url = `${apiUrl}Absences/GetAbsencesWithoutJustificationFile?languageId=${languageID}&startDate=${startDate}&endDate=${endDate}`;
    return ApiWithToken.getApiBlob(url);
  },
  CreateJustificationAbsencesInBulk: async function (dataRequest: IUploadJustificacationAbsencesDto) {
    let url = `${apiUrl}Absences/CreateJustificationAbsencesInBulk`;
    return ApiWithToken.postApi(url, dataRequest);
  },
  GetJustificationAbsences: async function (languageID: number, startDate: string, endDate: string) {
    let url = `${apiUrl}Absences/GetJustificationAbsences?languageID=${languageID}&startDate=${startDate}&endDate=${endDate}`;
    return ApiWithToken.getApi(url);
  },
  GetJustificationAbsenceTypes: async function (languageID: number) {
    let url = `${apiUrl}Absences/GetJustificationAbsenceTypes?languageID=${languageID}`;
    return ApiWithToken.getApi(url);
  },
  UpdateJustificationAbsenceType: async function (dataRequest: IUpdateJustificationAbsenceDto) {
    let url = `${apiUrl}Absences/UpdateJustificationAbsence`;
    return ApiWithToken.putApi(url, dataRequest);
  },
  DeleteJustificationAbsence: async function (idJustificationAbsence: number) {
    let url = `${apiUrl}Absences/DeleteJustificationAbsence?idJustificationAbsence=${idJustificationAbsence}`;
    return ApiWithToken.deleteApi(url);
  },
  GetJustificationAbsencesReport: async function (languageID: number, startDate: string, endDate: string) {
    let url = `${apiUrl}Absences/GetJustificationAbsencesReport?languageID=${languageID}&startDate=${startDate}&endDate=${endDate}`;
    return ApiWithToken.getApiBlob(url);
  },
}

export default justificationAbsencesService;